import { render, staticRenderFns } from "./ImgField.vue?vue&type=template&id=42dd326d"
import script from "./ImgField.vue?vue&type=script&lang=js"
export * from "./ImgField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports